export default {
  clients: [], // Historico
  clientes: [], // Lista geral
  client: null, // {id, id_cadastro_cliente, name, login, id_cliente_web}
  clientDatas: {
    data_atualizacao: {
      id_cliente: '',
      data: '',
    },
    data_cotizacao: {
      id_cliente: '',
      data: '',
    },
  },
  clientInfo: {
    has_incompletes_assets: false,
  },
  has_incompletes_assets: false,
  loading_user: false,
  user: {
    nome: '',
    id_interno: -1,
    escritorio: {
      nome: '',
      id_interno: -1,
      logo_name: 'logo-aawz.png',
    },
    loading: true,
    perfis_disponiveis: [], // 'gestor', 'profissional', 'cliente'
    tipo_usuario: '', // GESTOR, ASSESSOR, PLANEJADOR, CLIENTE
    IS_GESTOR: false,
    IS_ASSESSOR: false,
    IS_PLANEJADOR: false,
    IS_CLIENTE: true,
    avatar_url: null,
  },
  emails: [
    {
      email: 'aawz@aawz.com.br',
      validated: true,
    },
  ],
}
